import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { ExternalArticleCard } from './ExternalArticleCard';
import { featuredArticles } from '../data/externalArticles';

const useStyles = makeStyles(_theme => ({
  viewAllButton: {
    textTransform: 'none',
  },
}));

export const FeaturedReadingSection = () => {
  const classes = useStyles();

  // Only show articles marked as featured
  const displayArticles = featuredArticles.filter(article => article.featured !== false);

  return (
    <InfoCard
      title="Recommended Reading"
      subheader="Curated external articles and resources"
      action={
        <Button
          size="small"
          endIcon={<ArrowForwardIcon />}
          className={classes.viewAllButton}
          href="/docs/default/component/avid-developer-portal/ai-central/reading-list/"
        >
          View All
        </Button>
      }
    >
      <Grid container spacing={2}>
        {displayArticles.map(article => (
          <Grid item xs={12} sm={6} md={displayArticles.length === 2 ? 6 : 4} key={article.url}>
            <ExternalArticleCard article={article} />
          </Grid>
        ))}
      </Grid>
    </InfoCard>
  );
};
